import React from 'react';
import { Link } from 'react-router-dom';
import { ClockIcon, MapPinIcon, ArrowRightIcon } from 'lucide-react';
import { useDarkClasses } from '../../hooks/useDarkClasses';
import { useRoleTheme } from '../../hooks/useRoleTheme';
import { usePlatform } from '../../context/PlatformContext';
import { handleImgError } from '../../utils/imageUtils';
import { UpcomingEvent } from '../../data/homePageData';
interface EventTeaserCardProps {
  event: UpcomingEvent;
}
export const EventTeaserCard: React.FC<EventTeaserCardProps> = ({
  event
}) => {
  const dk = useDarkClasses();
  const rt = useRoleTheme();
  const {
    isAfterTide
  } = usePlatform();
  // Extract day and month for the date block
  const dateParts = event.date.split(' ');
  const month = dateParts[0]?.substring(0, 3) || '';
  const day = dateParts[1]?.replace(',', '') || '';
  return <div className="flex-shrink-0 w-[280px] sm:w-[300px] md:w-[320px]" data-id="element-1745" data-mp="gf2ueh8lyx3u">
      <div className={`rounded-xl shadow-sm overflow-hidden group hover:shadow-md transition-shadow border flex flex-col h-full ${dk.card}`} data-id="element-1746" data-mp="cftwr1ag6f30">
        <div className="h-32 relative" data-id="element-1747" data-mp="19og1cslmx5yd">
          <img src={event.image} alt={event.title} className="w-full h-full object-cover" onError={handleImgError} data-id="element-1748" data-mp="1eobws3g9np2b" />
          <div className="absolute inset-0 bg-black/40" data-id="element-1749" data-mp="1oex3yfa0a1wu"></div>

          {/* Date Block */}
          <div className={`absolute top-0 left-0 bottom-0 w-20 flex flex-col items-center justify-center text-white backdrop-blur-sm border-r border-white/10 ${isAfterTide ? 'bg-[#1a1a2e]/80' : 'bg-indigo-900/80'}`} data-id="element-1750" data-mp="qrg2gjil57ff">
            <span className="text-xs font-bold uppercase tracking-wider" data-id="element-1751" data-mp="10ot14a4n666w">
              {month}
            </span>
            <span className="text-3xl font-black leading-none my-1" data-id="element-1752" data-mp="15qa0203kfiku">{day}</span>
          </div>

          {/* Type Badge */}
          <div className="absolute top-3 right-3" data-id="element-1753" data-mp="2c73ugxt1veoc">
            <span className={`inline-block text-xs font-bold px-2.5 py-1 rounded-full text-white shadow-sm ${event.type === 'Virtual' ? isAfterTide ? 'bg-[#c77dba]' : 'bg-indigo-500' : 'bg-emerald-600'}`} data-id="element-1754" data-mp="2h2t11l3hlvu5">
              {event.type}
            </span>
          </div>
        </div>
        <div className="p-5 flex-1 flex flex-col" data-id="element-1755" data-mp="q0zrey200kbu">
          <div className="flex items-center mb-2 text-xs font-medium text-amber-500" data-id="element-1756" data-mp="m0phjab359rp">
            <ClockIcon className="h-3.5 w-3.5 mr-1" data-id="element-1757" data-mp="lyuzq4v41xru" />
            {event.time}
          </div>
          <h3 className={`font-bold text-lg mb-2 transition-colors ${dk.textPrimary} ${rt.textHover}`} data-id="element-1758" data-mp="3ue4ust0l22q4">
            {event.title}
          </h3>
          <p className={`text-sm mb-4 line-clamp-2 ${dk.textSecondary}`} data-id="element-1759" data-mp="74ztl6mcamkc">
            {event.description}
          </p>
          <div className="mt-auto space-y-3" data-id="element-1760" data-mp="2altiqwqfr9c">
            {event.location && <div className={`flex items-start text-sm ${dk.textMuted}`} data-id="element-1761" data-mp="3aqyvgwfxa996">
                <MapPinIcon className="h-4 w-4 mr-1.5 mt-0.5 flex-shrink-0" data-id="element-1762" data-mp="36pvfm9xvkd7y" />
                <span className="line-clamp-1" data-id="element-1763" data-mp="2wmgcdph27qnz">{event.location}</span>
              </div>}
            <Link to={`/events/${event.id}`} className={`inline-flex items-center font-medium text-sm ${rt.accentLink}`} data-id="element-1764" data-mp="31e86g9zfceiv">
              Learn more <ArrowRightIcon className="h-3.5 w-3.5 ml-1" data-id="element-1765" data-mp="2rnwohjiwo4sz" />
            </Link>
          </div>
        </div>
      </div>
    </div>;
};